import { getByID } from '@adornis/baseql/operations/mongo.js';
import { Workshop } from '@adornis/buchungsheld-db/entities/workshop.js';
import '@adornis/buchungsheld-theme/components/tr-chip.js';
import { TrDialog } from '@adornis/buchungsheld-theme/components/tr-dialog.js';
import '@adornis/buchungsheld-theme/components/tr-icon.js';
import '@adornis/buchungsheld-theme/fonts/fonts.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-hr.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { goTo } from '@adornis/router/client/open-href.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { filter, switchMap } from 'rxjs/operators';
import { smallIconButton } from '../components/bh-smol.js';

@customElement('bh-prompt-workshop-documents-view')
export class BHPromptWorkshopDocumentsView extends TrDialog<void> {
  static override get element_name() {
    return 'bh-prompt-workshop-documents-view';
  }

  @property({ attribute: false }) workshopID = new RXController<string>(this, undefined);

  @state() private readonly workshop = new RXController(
    this,
    this.workshopID.observable.pipe(
      filter(Boolean),
      switchMap(workshopID => getByID(Workshop, workshopID)({ documents: { title: 1, text: 1, fileID: 1 } })),
    ),
  );

  override content() {
    if (!this.workshop.value || !this.workshop.value.documents) return html` <tr-loading-state></tr-loading-state> `;
    const workshop = this.workshop.value;

    return html`
      <tr-flex space="md">
        <tr-h3 bold>${this._translation.translate('PROFILE', 'all_documents')}</tr-h3>
        <table>
          <tr>
            <th ${css({ textAlign: 'left' })}>${this._translation.translate('field', 'title')}</th>
            <th ${css({ textAlign: 'left' })}>${this._translation.translate('field', 'text')}</th>
            <th></th>
          </tr>
        ${workshop.documents!.map((document, index) => {
          if (!document.fileID) return;
          return html`
            <tr>
              <td>${document.title}</td>
              <td>${document.text}</td>
              <td>
                ${smallIconButton({
                  icon: 'download',
                  color: this.colors.secondary.shade(300),
                  action: () => {
                    if (!document.fileID) return;
                    const link = AdornisFile.getServeLink(document.fileID) + '/' + document.title;
                    goTo(link, { target: '_blank' });
                  },
                })}
              </td>
            </tr>
          `;
        })}
      </tr-flex>
    `;
  }
}
